import { ArrowRight } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgArrowThinRight = mkIcon(ArrowRight);